import { Link } from "react-router-dom";
import { Twitter, Linkedin, Github } from "lucide-react";
import Logo from "../Logo";

export default function Footer() {
  return (
    <footer className="mt-24 border-t border-border bg-background" data-testid="site-footer">
      <div className="container-x py-16 grid gap-10 md:grid-cols-5">
        <div className="md:col-span-2">
          <Logo to={null} />
          <p className="text-sm text-muted-foreground max-w-sm mt-5">
            The most trusted way to pass technical certification exams — sharp practice tests, deep analytics, real-exam simulation.
          </p>
          <div className="flex items-center gap-3 mt-5">
            <a href="#" className="rounded-md border border-border p-2 hover:bg-accent" aria-label="Twitter"><Twitter className="h-4 w-4" /></a>
            <a href="#" className="rounded-md border border-border p-2 hover:bg-accent" aria-label="LinkedIn"><Linkedin className="h-4 w-4" /></a>
            <a href="#" className="rounded-md border border-border p-2 hover:bg-accent" aria-label="GitHub"><Github className="h-4 w-4" /></a>
          </div>
        </div>

        <div>
          <div className="font-semibold mb-3">Practice tests</div>
          <ul className="space-y-2 text-sm text-muted-foreground">
            <li><Link to="/practice-tests/aws" className="hover:text-foreground">AWS</Link></li>
            <li><Link to="/practice-tests/azure" className="hover:text-foreground">Azure</Link></li>
            <li><Link to="/practice-tests/gcp" className="hover:text-foreground">Google Cloud</Link></li>
            <li><Link to="/practice-tests/kubernetes" className="hover:text-foreground">Kubernetes</Link></li>
            <li><Link to="/practice-tests/devops" className="hover:text-foreground">DevOps</Link></li>
          </ul>
        </div>

        <div>
          <div className="font-semibold mb-3">Company</div>
          <ul className="space-y-2 text-sm text-muted-foreground">
            <li><Link to="/pricing" className="hover:text-foreground">Pricing</Link></li>
            <li><Link to="/categories" className="hover:text-foreground">Categories</Link></li>
            <li><Link to="/compare" className="hover:text-foreground">Compare</Link></li>
            <li><Link to="/leaderboard" className="hover:text-foreground">Leaderboard</Link></li>
            <li><Link to="/about" className="hover:text-foreground">About</Link></li>
            <li><Link to="/contact" className="hover:text-foreground">Contact</Link></li>
          </ul>
        </div>

        <div>
          <div className="font-semibold mb-3">Legal</div>
          <ul className="space-y-2 text-sm text-muted-foreground">
            <li><Link to="/terms" className="hover:text-foreground">Terms</Link></li>
            <li><Link to="/privacy" className="hover:text-foreground">Privacy</Link></li>
            <li><Link to="/terms" className="hover:text-foreground">Refunds</Link></li>
            <li><Link to="/privacy" className="hover:text-foreground">Cookies</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-border">
        <div className="container-x py-5 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-muted-foreground">
          <div>© {new Date().getFullYear()} BeforeExam Labs. All rights reserved.</div>
          <div>Built for learners. 30-day money-back guarantee.</div>
        </div>
      </div>
    </footer>
  );
}
